import header_menu from '../ui/header_menu';
let headerMenuInit = false;
document.addEventListener("turbo:load", () => {
    if(!headerMenuInit){
    header_menu.init('.menu', '.toggle', 'has-menu-submenu', '.has-menu-submenu', 
    '.submenu-parent', '.active', '.menu-submenu-active', 
    '.menu-submenu', '.menu-item');
    }
    headerMenuInit = true;

    // User-menu dropdown (avatar circle). Single global owner for the
    // open/close behavior so it works in both the full nav (_nav.html.erb)
    // and the slim room header (_nav_room.html.erb). The room's
    // EventListeners.js intentionally does NOT wire this toggle to avoid
    // double-binding; it only wires #signature-icon -> signature modal.
    initUserMenu();
});

function initUserMenu() {
    const menu = document.querySelector('#user-menu');
    const toggle = document.querySelector('#user-menu-toggle');
    const panel = document.querySelector('#user-menu-panel');
    if (!menu || !toggle || !panel) return;

    // Guard against re-binding across turbo:load events (the elements
    // persist if the header isn't replaced).
    if (menu.dataset.userMenuBound === '1') return;
    menu.dataset.userMenuBound = '1';

    const openMenu = () => {
        panel.hidden = false;
        menu.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
    };
    const closeMenu = () => {
        panel.hidden = true;
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
    };
    const toggleMenu = () => {
        panel.hidden ? openMenu() : closeMenu();
    };

    toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        toggleMenu();
    });

    // Choosing an item closes the panel. Anchors navigate on their own;
    // the signature button's modal-open handler lives elsewhere (room
    // EventListeners.js or lobby_signature.js) and fires independently.
    panel.querySelectorAll('.user-menu-item').forEach((item) => {
        item.addEventListener('click', closeMenu);
    });

    // Click outside closes.
    document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) closeMenu();
    });

    // Escape closes.
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
    });
}
